// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorMessage_container__e3Bdt","reloadButton":"ErrorMessage_reloadButton__pGeva","message":"ErrorMessage_message__2OI-D"};